<template>
  <NavbarComponent :lightNav="'justify-start'" class="is-sticky bg-white dark:bg-slate-900" :container="'container'" />
  <RouterView />
  <FooterComponent class="mt-8" />
</template>

<script>
import NavbarComponent from '@/components/NavbarComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default {
  name: 'App',
  components: {
    NavbarComponent,
    FooterComponent
  }
}
</script>

<style>

</style>
